import { querySet } from "./url"
import {  MARKET_SDK_CHANNEL,EXTERNAL_MARKET_PAGE,EXTERNAL_W2A_PAGE } from "@/constants/common";
/**
 * 是否为mgm场景
 * @returns boolean
 */
export const isMgm = () => {
  return querySet.is_mgm === '1'
}

/**
 * 是否为外投场景
 * @returns boolean
 */
export const isMarket = () => {
  if (window.adv) {
    const { isAdvChannel } = window.adv
    return isAdvChannel && isAdvChannel()
  }
  return false
}

/**
 * 是否为官网场景
 * @returns boolean
 */
export const isOfficalWeb = () => {
  return querySet.is_offical_website === '1'
}

/**
 * 是否为Facebook
 * @returns boolean
 */
export const isFacebook = () => {
    if(isMarket()){
       return window?.adv?.getChannelEnv() === MARKET_SDK_CHANNEL.meta
    }else{
       return false
    }
 
}

/**
 * 是否为Google
 * @returns boolean
 */
export const isGoogle = () => {
  if(isMarket()){
    return window?.adv?.getChannelEnv() === MARKET_SDK_CHANNEL.google
 }else{
    return false
 }
}

/**
 * 是否为Tiktok
 * @returns boolean
 */
export const isTiktok = () => {
  if(isMarket()){
    return window?.adv?.getChannelEnv() === MARKET_SDK_CHANNEL.tiktok
 }else{
    return false
 }
}
// 判断是否为营销打开
export const isFromMarKeTing = () => {
  const { fromPage} = querySet
  return  fromPage === EXTERNAL_MARKET_PAGE || fromPage === EXTERNAL_W2A_PAGE
}

